import { Link, Outlet, useLocation } from 'react-router-dom';
import { AI_HOME_PATH, AI_MENU } from '../../lib/ai-menu';
import { AiHistory, AiNewChatButton } from './AiHistory';
import { AiUsageFoot } from './AiUsageFoot';
import './AiShell.css';
/*
 * 시안 버전 7 의 «선으로 가르는» 결. `AiShell.css` 뒤에 와야 하고, 규칙이 전부
 * `.aishell--oa` 로 한 겹 더 조여 있어 **이 import 와 아래 클래스 하나를 빼면 옛 결로 돌아온다.**
 */
import './AiOa.css';

/**
 * AI 셸 — 좌 240px 트리 + 우 화면(`<Outlet/>`) (설계 판 A · 정의서 M2).
 *
 * 근태 셸(`AttShell`)·인사 셸(`HrShell`)과 **같은 규칙·같은 치수**다. 클래스 이름만 따로 둔다
 * (`ainav-*`) — 같은 이름을 두 도메인이 나눠 쓰면 한쪽을 고칠 때 다른 쪽이 함께 움직인다.
 *
 * ★★★ **240 이지 280 이 아니다.** 정본은 A2(240 · 「어디로 갈지」 라우트 트리)와
 *    A8(280 · 「무엇을 볼지」 데이터 목록)을 갈라 놓았고 「A 와 C 를 섞지 않는다」고 못 박았다.
 *    이 패널은 하위 화면 셋으로 **라우트를 가르므로** A 쪽이다(정의서 M2).
 *
 * ★★ **찾기 칸을 안 준다.** 정본 A2 는 「항목 20+ 일 때만」이라 적었고 판 A 의 항목은 하나다.
 *    한 줄짜리 목록 위에 검색창을 얹으면 그게 더 이상하다. 하위가 늘면 그때 준다.
 *
 * ★★ **판 C 부터 「새 대화」와 이력이 선다.** 판 A 때는 대화를 담을 표가 없어 안 세웠다 —
 *    눌러도 갈 곳이 없는 단추를 세우면 그게 잘못된 안내이기 때문이다. 이제 표가 있다.
 *
 * ── 바닥은 셸이 «한 번만» 칠한다 (정본 F2) ────────────────────────────────
 * 바닥 `--field` · 좌측 면 `--paper`. 화면(`<Outlet/>` 쪽)은 제 바닥을 칠하지 않는다 —
 * 칠하면 흰 셸 안에 회색 사각형이 하나 더 생겨 「바탕이 두 겹」으로 보인다(근태 셸이 겪은 것).
 */
export function AiShell() {
  const { pathname } = useLocation();

  /** 뿌리(`/ai`)만 정확히 일치로 켠다 — 아니면 하위 화면에서 둘이 함께 켜진다. */
  const isOn = (to: string) =>
    to === AI_HOME_PATH ? pathname === AI_HOME_PATH : pathname === to || pathname.startsWith(`${to}/`);

  return (
    <div className="aishell aishell--oa">
      <nav className="ainav" aria-label="AI 메뉴">
        <div className="ainav__head">
          <h2 className="ainav__title">AI</h2>
        </div>

        {/*
          ★★★ **차례가 곧 규칙이다** (2026-09-11 사용자 지시):
            새 대화 → 하위 메뉴(고정) → 이력(구른다).
          예전에는 이력이 위에 있어, 대화가 쌓이면 **하위 메뉴가 아래로 밀려 안 보였다**.
          이제 메뉴는 그 자리에 못 박히고 **이력만 구른다**(아래 `.ainav__hist`).
        */}
        <AiNewChatButton />

        <div className="ainav__group">
          {AI_MENU.map((i) => {
            const Icon = i.icon;
            const on = isOn(i.to);
            return (
              <Link
                key={i.to}
                to={i.to}
                className={`ainav__item${on ? ' is-on' : ''}`}
                aria-current={on ? 'page' : undefined}
              >
                <Icon size={17} aria-hidden />
                <span className="ainav__nm">{i.label}</span>
                <span className="ainav__hint">{i.hint}</span>
              </Link>
            );
          })}
        </div>

        {/* 이력만 구른다 — 위의 메뉴는 고정이다. */}
        <div className="ainav__hist">
          <AiHistory />
        </div>

        {/* 판 K — 하위메뉴 «제일 아래»에 사용량(2026-09-10 사용자 지적). */}
        <AiUsageFoot />
      </nav>

      <div className="ainav__body">
        <Outlet />
      </div>
    </div>
  );
}
